var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgUpoloipo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    id: "Layer_1-2",
    width: 219.927,
    height: 140.544,
    viewBox: "0 0 219.927 140.544",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_195",
    "data-name": "Rectangle 195",
    width: 165.88,
    height: 139.879,
    fill: "none"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17720",
    "data-name": "Path 17720",
    d: "M178.507,53.028s-14.4,4.987-18.807,26.488c0,0,9.789,5.377,19.383,6.529,0,0,13.439-35.125-.576-33.017Z",
    transform: "translate(-159.7 -52.937)",
    fill: "#0d3b66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-3"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17727",
    "data-name": "Path 17727",
    d: "M222.84,118.517s-3.083.576-7.769,1.24c-.2.027-.39.053-.549.08a2.227,2.227,0,0,0-.239.035c-.1.018-.195.027-.292.044s-.168.018-.23.027a.225.225,0,0,0-.106.018h-.062c-.053,0-.106.018-.159.018-2.126.283-4.509.576-7.043.833-3.065.31-6.352.576-9.656.718-3.34.151-6.706.177-9.886.027-.478-.027-.948-.053-1.426-.089-1.329-.089-2.622-.221-3.854-.39-16.017-2.179-16.787-4.1-16.787-4.1a40.518,40.518,0,0,0,4.128-10.994,47.856,47.856,0,0,0,.735-14.121c-.115-1.426-1.107-12.943-.974-16.141.018-.514.053-1.01.106-1.5a16.493,16.493,0,0,1,.735-3.375c2.259-7.114,5-15.742,9.523-18.594a34.388,34.388,0,0,1,4.27-2.206c.718-.3,1.488-.594,2.312-.859a.612.612,0,0,0,.071-.027h0a30,30,0,0,1,3.34-.877,30.338,30.338,0,0,1,10.506-.239c.62.1,1.258.195,2.055.381a.126.126,0,0,1,.053.018,23.693,23.693,0,0,1,9.656,5.537,16.771,16.771,0,0,1,3.818,6.644c2.454,7.087,2.675,16.132,2.7,17.354a221.8,221.8,0,0,0,4.979,40.555Z",
    transform: "translate(-164.78 -47.699)",
    fill: "#0d3b66"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-4"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17758",
    "data-name": "Path 17758",
    d: "M61.054,73.142l13.129,30.58a.354.354,0,0,0,.319.239h47.27c.283,0,.461-.39.31-.7l-14.688-30.58a.362.362,0,0,0-.31-.221H61.373c-.275,0-.452.372-.319.673Z",
    transform: "translate(-61.009 -72.46)",
    fill: "#95b8d1"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path-5"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17764",
    "data-name": "Path 17764",
    d: "M185.91,78.445s16.7-25.912,23.228-24.76,9.408,5.758,9.408,11.135S210.1,95.339,210.1,95.339s-16.318-4.987-24.184-16.894Z",
    transform: "translate(-185.91 -53.648)",
    fill: "#0d3b66"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1206",
    "data-name": "Group 1206"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17707",
    "data-name": "Path 17707",
    d: "M219.555,158.554H.372a.372.372,0,1,1,0-.744H219.555a.372.372,0,1,1,0,.744Z",
    transform: "translate(0 -18.01)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1177",
    "data-name": "Group 1177",
    transform: "translate(17.939 8.398)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1174",
    "data-name": "Group 1174"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17708",
    "data-name": "Path 17708",
    d: "M65.7,58.595a7.442,7.442,0,0,0-5.873-2.17L25.1,56.407a4.089,4.089,0,0,1-4.3-4.234v-37.9a4.089,4.089,0,0,1,4.3-4.234H79.542a4.089,4.089,0,0,1,4.3,4.234V66.151c0,4.234-4.624,5.306-7.335,2.312L65.7,58.6Z",
    transform: "translate(-20.313 -9.544)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17709",
    "data-name": "Path 17709",
    d: "M80.038,70.605a5.4,5.4,0,0,1-3.96-1.869L65.306,58.912l-.035-.035c-1.24-1.364-2.985-2-5.5-2.011l-34.726-.018a4.605,4.605,0,0,1-4.793-4.731V14.211A4.61,4.61,0,0,1,25.043,9.48H79.488a4.605,4.605,0,0,1,4.793,4.731V66.078A4.281,4.281,0,0,1,81.632,70.3a4.5,4.5,0,0,1-1.595.292ZM66,58.185l10.781,9.842a4.137,4.137,0,0,0,4.483,1.355,3.28,3.28,0,0,0,2.011-3.3V14.211a3.6,3.6,0,0,0-3.792-3.73H25.034a3.6,3.6,0,0,0-3.792,3.73V52.117a3.6,3.6,0,0,0,3.792,3.73l34.726.018a8,8,0,0,1,6.228,2.321Z",
    transform: "translate(-20.25 -9.48)"
  })), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_169",
    "data-name": "Rectangle 169",
    width: 51.381,
    height: 38.978,
    rx: 3.72,
    transform: "translate(6.529 4.429)",
    fill: "#cc745f"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1175",
    "data-name": "Group 1175",
    transform: "translate(15.326 7.769)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_170",
    "data-name": "Rectangle 170",
    width: 33.69,
    height: 0.726,
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_171",
    "data-name": "Rectangle 171",
    width: 33.69,
    height: 0.726,
    transform: "translate(0 24.362)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_172",
    "data-name": "Rectangle 172",
    width: 14.023,
    height: 0.868,
    transform: "translate(0 5.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_173",
    "data-name": "Rectangle 173",
    width: 12.145,
    height: 0.868,
    transform: "translate(0 8.292)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_174",
    "data-name": "Rectangle 174",
    width: 12.145,
    height: 0.868,
    transform: "translate(0 18.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_175",
    "data-name": "Rectangle 175",
    width: 7.158,
    height: 0.868,
    transform: "translate(26.381 18.94)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 15.467,
    height: 0.868,
    transform: "translate(0 10.958)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_177",
    "data-name": "Rectangle 177",
    width: 10.117,
    height: 0.868,
    transform: "translate(0 13.616)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_178",
    "data-name": "Rectangle 178",
    width: 14.387,
    height: 0.868,
    transform: "translate(0 16.273)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_179",
    "data-name": "Rectangle 179",
    width: 6.29,
    height: 0.868,
    transform: "translate(26.745 5.634)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_180",
    "data-name": "Rectangle 180",
    width: 3.756,
    height: 0.868,
    transform: "translate(28.011 8.38)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_181",
    "data-name": "Rectangle 181",
    width: 12.145,
    height: 0.868,
    transform: "translate(0 29.473)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_182",
    "data-name": "Rectangle 182",
    width: 3.756,
    height: 0.868,
    transform: "translate(28.011 29.562)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_183",
    "data-name": "Rectangle 183",
    width: 7.016,
    height: 0.868,
    transform: "translate(26.381 11.127)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_184",
    "data-name": "Rectangle 184",
    width: 2.888,
    height: 0.868,
    transform: "translate(28.445 13.873)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_185",
    "data-name": "Rectangle 185",
    width: 4.987,
    height: 0.868,
    transform: "translate(27.4 16.628)",
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1176",
    "data-name": "Group 1176",
    transform: "translate(5.989 3.526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17710",
    "data-name": "Path 17710",
    d: "M74.511,56.035H32.051a5.043,5.043,0,0,1-5.041-5.041V34.366a.5.5,0,1,1,.992,0V50.994a4.043,4.043,0,0,0,4.04,4.04H74.5a.5.5,0,0,1,0,.992Z",
    transform: "translate(-27.01 -15.789)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17711",
    "data-name": "Path 17711",
    d: "M79.641,42.756a.5.5,0,0,1-.5-.5V18.492a4.049,4.049,0,0,0-4.04-4.04H32.636a.5.5,0,1,1,0-.992H75.1A5.043,5.043,0,0,1,80.137,18.5V42.269a.5.5,0,0,1-.5.5Z",
    transform: "translate(-27.595 -13.46)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "woman_2",
    transform: "translate(49.051)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1205",
    "data-name": "Group 1205",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "woman_1",
    transform: "translate(1.807 7.584)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1180",
    "data-name": "Group 1180",
    transform: "translate(19.799 69.123)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1178",
    "data-name": "Group 1178"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17712",
    "data-name": "Path 17712",
    d: "M104.912,103.341c-1.719,1.107-13.244,8.425-16.7,6.166-.5-.328-1.683-1.1-1.736-2.294v-.186a2.741,2.741,0,0,1,.824-1.674h0a3.284,3.284,0,0,1,.4-.372,9.023,9.023,0,0,1-1.373.788h0a3.464,3.464,0,0,1-2.436.354c-1.187-.416-1.533-2.064-1.55-2.179a4.184,4.184,0,0,1,2.038-4.11c-.018,0-.115.027-.257.053s-.337.062-.567.089c-.93.106-2.4.106-3.021-.788s-.1-2.179.115-2.7c1.276-3.225,6.892-6.857,14.573-8.531a43.14,43.14,0,0,1,22.014,1.178c15.441,23.059-12.331,14.209-12.331,14.209Z",
    transform: "translate(-79.815 -86.642)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17713",
    "data-name": "Path 17713",
    d: "M87.919,109.818a3.627,3.627,0,0,1-1.931-2.64v-.23a3.047,3.047,0,0,1,.142-.709,3.5,3.5,0,0,1-2.445.239,3.43,3.43,0,0,1-1.834-2.5,4.235,4.235,0,0,1,1.107-3.579,3.155,3.155,0,0,1-2.835-1.019c-.744-1.072-.151-2.551.062-3.1,1.417-3.579,7.539-7.193,14.883-8.788A44.238,44.238,0,0,1,117.3,88.681a.406.406,0,0,1,.23.168c4.536,6.777,5.82,11.561,3.818,14.218-3.366,4.474-14.75,1.214-16.442.7-3.473,2.224-10.781,6.555-15,6.555a3.633,3.633,0,0,1-2-.5Zm17.071-6.936c.124.035,12.491,3.916,15.689-.337,1.745-2.321.478-6.724-3.765-13.093a43.234,43.234,0,0,0-21.651-1.125C87,90.125,82.072,93.872,80.991,96.6c-.177.434-.638,1.6-.159,2.3.5.735,1.86.7,2.613.611.213-.027.4-.053.532-.08.115-.018.195-.044.239-.053a.43.43,0,0,1,.487.248.424.424,0,0,1-.159.523,3.719,3.719,0,0,0-1.851,3.668c0,.018.3,1.506,1.276,1.851a2.992,2.992,0,0,0,2.091-.328.089.089,0,0,1,.027-.009,7.943,7.943,0,0,0,1.3-.744.421.421,0,0,1,.585.089.43.43,0,0,1-.062.594,3.4,3.4,0,0,0-.363.337,2.3,2.3,0,0,0-.7,1.4v.142c.044.974,1.1,1.665,1.541,1.958,2.436,1.595,10.267-2.33,16.238-6.166a.439.439,0,0,1,.23-.071.345.345,0,0,1,.133.018Z",
    transform: "translate(-79.759 -86.59)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1179",
    "data-name": "Group 1179",
    transform: "translate(17.057 12.444)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17714",
    "data-name": "Path 17714",
    d: "M116.161,101.376c-2.374-.78-3.145.337-8.478,1.2-4.491.726-6.538.354-7.619,1.993a3.378,3.378,0,0,0-.443,2.684c1.639,4.367,17.841,2.888,20.118-.877a2.478,2.478,0,0,0,.39-1.338c-.062-1.71-2.3-3.118-3.969-3.668Z",
    transform: "translate(-99.067 -100.691)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17715",
    "data-name": "Path 17715",
    d: "M105.212,110.2c-2.348-.221-5.3-.895-6.033-2.853a3.769,3.769,0,0,1,.487-3.065c.886-1.347,2.321-1.5,4.677-1.763.921-.1,1.967-.213,3.225-.416a41.134,41.134,0,0,0,4.474-.983c1.7-.461,2.631-.709,4.208-.195,1.444.47,4.2,1.931,4.27,4.057a2.868,2.868,0,0,1-.452,1.568c-1.417,2.33-7.379,3.756-12.553,3.756-.8,0-1.568-.035-2.3-.106Zm7.052-8.256a40.4,40.4,0,0,1-4.553,1c-1.276.2-2.339.328-3.269.425-2.259.248-3.393.372-4.057,1.382a2.975,2.975,0,0,0-.4,2.294c.443,1.187,2.383,2.02,5.315,2.294,5.661.532,12.748-1.107,14.041-3.242a1.975,1.975,0,0,0,.328-1.1c-.044-1.355-1.931-2.7-3.676-3.269h0a4.311,4.311,0,0,0-1.373-.239,9.152,9.152,0,0,0-2.348.452Z",
    transform: "translate(-99.013 -100.637)"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1181",
    "data-name": "Group 1181",
    transform: "translate(91.517 39.461)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17716",
    "data-name": "Path 17716",
    d: "M180.708,53.59s-14.5,9.107-16.424,20.623-3.074,21.305-3.074,21.305l11.135,1.727Z",
    transform: "translate(-160.773 -53.161)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17717",
    "data-name": "Path 17717",
    d: "M172.218,97.616l-11.135-1.727a.433.433,0,0,1-.363-.478c.009-.1,1.178-9.931,3.074-21.323,1.931-11.57,16.017-20.535,16.619-20.915a.43.43,0,0,1,.47.009.42.42,0,0,1,.177.434L172.7,97.27a.428.428,0,0,1-.425.345H172.2Zm-7.574-23.387c-1.674,10.055-2.782,18.9-3.021,20.871l10.312,1.6,8.088-42.238c-3.1,2.153-13.784,10.17-15.388,19.764Z",
    transform: "translate(-160.717 -53.106)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1184",
    "data-name": "Group 1184",
    transform: "translate(90.616 39.311)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17718",
    "data-name": "Path 17718",
    d: "M178.507,53.028s-14.4,4.987-18.807,26.488c0,0,9.789,5.377,19.383,6.529,0,0,13.439-35.125-.576-33.017Z",
    transform: "translate(-159.7 -52.937)",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1183",
    "data-name": "Group 1183"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17719",
    "data-name": "Path 17719",
    d: "M178.507,53.028s-14.4,4.987-18.807,26.488c0,0,9.789,5.377,19.383,6.529,0,0,13.439-35.125-.576-33.017Z",
    transform: "translate(-159.7 -52.937)",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1182",
    "data-name": "Group 1182",
    clipPath: "url(#clip-path-2)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_186",
    "data-name": "Rectangle 186",
    width: 29.234,
    height: 71.756,
    transform: "translate(-2.728 -2.177)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACEAAABRCAYAAABcxs+uAAAACXBIWXMAAAsSAAALEgHS3X78AAAAuElEQVRoge3awQ2CQBBG4V/rsgo7sDI7sAr7wnh4ZlwuHMDZxPcdCYmPHQMbwimD+/WyjMduj+fqvD1tijhCvbC2iOr86x8cvVekPSIzrESMKIyAEZgvouOWvYroYgSMgBEwAq0R7LhdCRgBI2AEjMAnomuTG8dRGAEjYAT+O6K+VnYcMAJGwAjME9G5v4zjKIyAETACRqAlYvwoxHHACBgBIzBHRPcmN46jMAK7fme59U/+9ShP8gKnFR7LaJGbAwAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17721",
    "data-name": "Path 17721",
    d: "M178.507,53.028s-14.4,4.987-18.807,26.488c0,0,9.789,5.377,19.383,6.529,0,0,13.439-35.125-.576-33.017Z",
    transform: "translate(-159.7 -52.937)",
    fill: "#0d3b66"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1185",
    "data-name": "Group 1185",
    transform: "translate(56.244 69.885)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17722",
    "data-name": "Path 17722",
    d: "M167.8,101.16c-.523,1.86-2.365,3.349-5.554,4.465a14.48,14.48,0,0,1-2.25.673c-5.236,1.045-35.417-1.32-37.685-1.5,1.772-3.747,2.17-5.129,2.064-5.519,0-.018-.3-1.036-.363-1.214-.018-.071-.044-.133-.062-.2l-.027-.106c-.018-.071-.044-.142-.062-.213-.071-.248-.151-.514-.23-.78-.018-.071-.044-.142-.062-.213s-.044-.159-.071-.239c-.035-.106-.062-.221-.1-.328-.062-.213-.124-.425-.186-.62l-.053-.186c-.027-.089-.053-.168-.071-.257-.018-.044-.027-.1-.044-.142v-.018a.739.739,0,0,1-.035-.133c-.009-.044-.027-.08-.035-.115a.126.126,0,0,0-.018-.053c-.009-.027-.018-.062-.027-.089s-.018-.044-.018-.071a.225.225,0,0,1-.018-.062q-.744-2.511-1.488-5.014,18.4-.664,36.8-1.338a45.248,45.248,0,0,1,6.8,6.13q3.614,4.172,2.79,7.114Z",
    transform: "translate(-120.959 -87.5)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17723",
    "data-name": "Path 17723",
    d: "M122.22,105.185a.416.416,0,0,1-.337-.213.425.425,0,0,1-.018-.4c2-4.234,2.064-5.067,2.038-5.218-.009-.035-.3-1.028-.354-1.2l-.062-.195.408-.133-.425.071-.018-.053-.877-2.95s0-.027-.009-.035l-.071-.239.408-.124-.434.053-.035-.124-.027-.071h0l-1.488-5.014a.426.426,0,0,1,.4-.549l36.8-1.338a.426.426,0,0,1,.275.089,46.165,46.165,0,0,1,6.874,6.192c2.5,2.888,3.464,5.413,2.879,7.5h0c-.558,1.993-2.516,3.6-5.8,4.748a15.138,15.138,0,0,1-2.33.7,31.169,31.169,0,0,1-5.076.275c-10.126,0-30.022-1.55-32.724-1.763Zm-.31-15.574,1.347,4.536-.408.133.425-.071s.027.089.027.1l.018.062.062.23a.417.417,0,0,0,.018.044l.966,3.251c.053.177.354,1.2.363,1.223.124.425-.018,1.373-1.825,5.262,4.624.363,32.06,2.436,36.95,1.453a15.3,15.3,0,0,0,2.2-.656c3.03-1.063,4.8-2.472,5.28-4.181h0c.5-1.8-.408-4.066-2.7-6.715a44.433,44.433,0,0,0-6.617-5.98l-36.1,1.311Z",
    transform: "translate(-120.9 -87.45)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17724",
    "data-name": "Path 17724",
    d: "M162.068,228.847c.372,15.724.744,38.686.514,67.025q13.075.5,26.142,1.028,2.791-138.422,4.615-138.409t2.693,138.923l27.294-1.541c-1.267-73.12-.815-103.426-.035-116.758a205.967,205.967,0,0,0-.859-41.521c-.124-.992-.239-1.9-.337-2.711l-.948-7.548-56.625-2.294c-.213,2.011-.452,4.3-.691,6.839-.718,7.548-1.5,17.319-2.02,28.649-1.214,25.992-.337,43.461.257,68.31Z",
    transform: "translate(-69.256 -21.855)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1188",
    "data-name": "Group 1188",
    transform: "translate(95.116 34.671)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17725",
    "data-name": "Path 17725",
    d: "M222.84,118.517s-3.083.576-7.769,1.24c-.2.027-.39.053-.549.08a2.227,2.227,0,0,0-.239.035c-.1.018-.195.027-.292.044s-.168.018-.23.027a.225.225,0,0,0-.106.018h-.062c-.053,0-.106.018-.159.018-2.126.283-4.509.576-7.043.833-3.065.31-6.352.576-9.656.718-3.34.151-6.706.177-9.886.027-.478-.027-.948-.053-1.426-.089-1.329-.089-2.622-.221-3.854-.39-16.017-2.179-16.787-4.1-16.787-4.1a40.518,40.518,0,0,0,4.128-10.994,47.856,47.856,0,0,0,.735-14.121c-.115-1.426-1.107-12.943-.974-16.141.018-.514.053-1.01.106-1.5a16.493,16.493,0,0,1,.735-3.375c2.259-7.114,5-15.742,9.523-18.594a34.388,34.388,0,0,1,4.27-2.206c.718-.3,1.488-.594,2.312-.859a.612.612,0,0,0,.071-.027h0a30,30,0,0,1,3.34-.877,30.338,30.338,0,0,1,10.506-.239c.62.1,1.258.195,2.055.381a.126.126,0,0,1,.053.018,23.693,23.693,0,0,1,9.656,5.537,16.771,16.771,0,0,1,3.818,6.644c2.454,7.087,2.675,16.132,2.7,17.354a221.8,221.8,0,0,0,4.979,40.555Z",
    transform: "translate(-164.78 -47.699)",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1187",
    "data-name": "Group 1187"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17726",
    "data-name": "Path 17726",
    d: "M222.84,118.517s-3.083.576-7.769,1.24c-.2.027-.39.053-.549.08a2.227,2.227,0,0,0-.239.035c-.1.018-.195.027-.292.044s-.168.018-.23.027a.225.225,0,0,0-.106.018h-.062c-.053,0-.106.018-.159.018-2.126.283-4.509.576-7.043.833-3.065.31-6.352.576-9.656.718-3.34.151-6.706.177-9.886.027-.478-.027-.948-.053-1.426-.089-1.329-.089-2.622-.221-3.854-.39-16.017-2.179-16.787-4.1-16.787-4.1a40.518,40.518,0,0,0,4.128-10.994,47.856,47.856,0,0,0,.735-14.121c-.115-1.426-1.107-12.943-.974-16.141.018-.514.053-1.01.106-1.5a16.493,16.493,0,0,1,.735-3.375c2.259-7.114,5-15.742,9.523-18.594a34.388,34.388,0,0,1,4.27-2.206c.718-.3,1.488-.594,2.312-.859a.612.612,0,0,0,.071-.027h0a30,30,0,0,1,3.34-.877,30.338,30.338,0,0,1,10.506-.239c.62.1,1.258.195,2.055.381a.126.126,0,0,1,.053.018,23.693,23.693,0,0,1,9.656,5.537,16.771,16.771,0,0,1,3.818,6.644c2.454,7.087,2.675,16.132,2.7,17.354a221.8,221.8,0,0,0,4.979,40.555Z",
    transform: "translate(-164.78 -47.699)",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1186",
    "data-name": "Group 1186",
    clipPath: "url(#clip-path-3)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_187",
    "data-name": "Rectangle 187",
    width: 62.897,
    height: 77.957,
    transform: "translate(-1.028 -1.966)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEcAAABYCAYAAACnMOpRAAAACXBIWXMAAAsSAAALEgHS3X78AAABIUlEQVR4nO3cQWrCUBRA0ei6ugp34Mq6A1fRfbVUsJivXrAYDOGcYcjEyxskD/N30+Dz8PE9Xrs4nr5u7t+yp+IsYc3B3x5nCa8Kvsk4r7Lfxs9YhjhBnCBOECeIE8QJ4gRxgjhBnAd+38/ECeIEcYI4QZwgTpjFsQWcMzlBnCBOECeIE8QJ4gRxgjhBnCBOECeIE8S54/LnJ3GCOEGcIE4QJ4gT/uJYrt8yOUGcIE4QJ4gTxAniBHGCOEGcIE4QJ4gTxBlcf1ksThAniBPECeKEcxz74/tMThAniBPECeIEcYI4QZwgThAniBPECeIEca6MJ1OKE8QJ4gRxgjhBnLC3XH/M5ISnj+Pe8qSND4FvPxx+TbFXF2cJ/w0+izNN0w9WbirW/a7fQQAAAABJRU5ErkJggg=="
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17728",
    "data-name": "Path 17728",
    d: "M222.84,118.517s-3.083.576-7.769,1.24c-.2.027-.39.053-.549.08a2.227,2.227,0,0,0-.239.035c-.1.018-.195.027-.292.044s-.168.018-.23.027a.225.225,0,0,0-.106.018h-.062c-.053,0-.106.018-.159.018-2.126.283-4.509.576-7.043.833-3.065.31-6.352.576-9.656.718-3.34.151-6.706.177-9.886.027-.478-.027-.948-.053-1.426-.089-1.329-.089-2.622-.221-3.854-.39-16.017-2.179-16.787-4.1-16.787-4.1a40.518,40.518,0,0,0,4.128-10.994,47.856,47.856,0,0,0,.735-14.121c-.115-1.426-1.107-12.943-.974-16.141.018-.514.053-1.01.106-1.5a16.493,16.493,0,0,1,.735-3.375c2.259-7.114,5-15.742,9.523-18.594a34.388,34.388,0,0,1,4.27-2.206c.718-.3,1.488-.594,2.312-.859a.612.612,0,0,0,.071-.027h0a30,30,0,0,1,3.34-.877,30.338,30.338,0,0,1,10.506-.239c.62.1,1.258.195,2.055.381a.126.126,0,0,1,.053.018,23.693,23.693,0,0,1,9.656,5.537,16.771,16.771,0,0,1,3.818,6.644c2.454,7.087,2.675,16.132,2.7,17.354a221.8,221.8,0,0,0,4.979,40.555Z",
    transform: "translate(-164.78 -47.699)",
    fill: "#0d3b66"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17729",
    "data-name": "Path 17729",
    d: "M223.356,12.847a.674.674,0,0,0-1.223-.567.817.817,0,0,0-.062.319L208.89,23.309l.487.594L222.55,13.2a.668.668,0,0,0,.8-.354Z",
    transform: "translate(-74.698 -8.941)",
    fill: "#f86e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17730",
    "data-name": "Path 17730",
    d: "M218.782,27.923l-.549.974-2.463-9.762.647-.585Z",
    transform: "translate(-75.483 -9.701)",
    fill: "#f86e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17731",
    "data-name": "Path 17731",
    d: "M184.746,21.1a11.117,11.117,0,0,1,.47-4.2,11.6,11.6,0,0,1,1.931-3.6,11.469,11.469,0,0,1,4.022-3.668,11.743,11.743,0,0,1,2.808-.957c3.641-.682,10.152,1.453,13.527,6.945A14.794,14.794,0,0,1,207.4,31.2c-2.764,4.119-8.079,6.493-9.541,5.351a3.235,3.235,0,0,1-.966-2.808,2.878,2.878,0,0,1,.195-.567c1.719-4.288,3.6-5.014,3.508-6.369-.106-1.7-3.269-3.783-15.839-5.714Z",
    transform: "translate(-71.939 -8.561)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17732",
    "data-name": "Path 17732",
    d: "M180.838,52.613a.429.429,0,0,0,.23-.062,33.855,33.855,0,0,1,4.208-2.17c.771-.328,1.515-.6,2.277-.85,0,0,.044-.018.071-.027h.018a28.644,28.644,0,0,1,3.3-.868,29.886,29.886,0,0,1,10.356-.239,20.025,20.025,0,0,1,2.02.381s.062.018.071.018a22.508,22.508,0,0,1,5.59,2.48.431.431,0,1,0,.452-.735,22.575,22.575,0,0,0-5.847-2.578s-.071-.018-.08-.018c-.806-.195-1.479-.3-2.073-.39a30.7,30.7,0,0,0-10.648.248,30.03,30.03,0,0,0-3.375.886h-.009a.5.5,0,0,0-.106.035c-.753.239-1.524.532-2.321.868a35.3,35.3,0,0,0-4.332,2.232.429.429,0,0,0-.133.594.423.423,0,0,0,.363.2Z",
    transform: "translate(-71.45 -12.972)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1189",
    "data-name": "Group 1189",
    transform: "translate(115.078 17.273)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17733",
    "data-name": "Path 17733",
    d: "M188.259,46.993a.2.2,0,0,1,.035-.009.053.053,0,0,0,.035-.009h0c.753-.248,1.55-.461,2.383-.656V28.54h9.2V45.593c.726.053,1.479.133,2.268.257.62.1,1.258.195,2.055.381A17.818,17.818,0,0,1,199.2,51.9a13.976,13.976,0,0,1-9.054,2.853,6.982,6.982,0,0,1-1.9-7.76Z",
    transform: "translate(-187.367 -28.115)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17734",
    "data-name": "Path 17734",
    d: "M190.092,55.123a.418.418,0,0,1-.266-.106,7.432,7.432,0,0,1-2.241-3.561,7.524,7.524,0,0,1,.221-4.669.556.556,0,0,1,.3-.266l.053-.018h0c.611-.2,1.293-.39,2.073-.585V28.485a.425.425,0,0,1,.425-.425h9.2a.425.425,0,0,1,.425.425V45.14c.647.053,1.276.133,1.9.221.594.089,1.267.195,2.1.39a.434.434,0,0,1,.292.248.441.441,0,0,1-.018.381,18.318,18.318,0,0,1-5.156,5.811,14.767,14.767,0,0,1-2.985,1.754,14.456,14.456,0,0,1-5.794,1.187c-.177,0-.354,0-.54-.009Zm11.977-8.912c-.726-.106-1.462-.195-2.232-.248a.433.433,0,0,1-.4-.425V28.91H191.1V46.256a.426.426,0,0,1-.328.416c-.85.2-1.586.4-2.232.611a6.556,6.556,0,0,0,1.745,6.99,13.694,13.694,0,0,0,5.8-1.107,14.209,14.209,0,0,0,2.835-1.665,17.567,17.567,0,0,0,4.615-5.032c-.54-.115-1-.177-1.453-.248Z",
    transform: "translate(-187.314 -28.06)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1190",
    "data-name": "Group 1190",
    transform: "translate(110.041 5.264)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17735",
    "data-name": "Path 17735",
    d: "M182.165,26.433a6.9,6.9,0,0,1,1.116-2.649c.469-.78.78-1.16,1.1-1.621,1.444-2.082,2.294-4.7,3.481-6.529a1.345,1.345,0,0,1,.833-.664c3.4,2.578,5.36,3.969,6.768,4.846a13.906,13.906,0,0,1,3.8,3.216c.567.709.7,1.152,1.063,1.568a1.8,1.8,0,0,1,.381,1.045,2.008,2.008,0,0,1,1.639.018,2.465,2.465,0,0,1,.895,2.445,3.814,3.814,0,0,1-2.038,2.4,7.039,7.039,0,0,1-2.374.974l-.372.8c-.912,1.913-1.382,2.888-2.2,3.543-1.2.966-2.48,1.134-4.979,1.409a22.075,22.075,0,0,1-3.986.257,5.262,5.262,0,0,1-3-1,4.665,4.665,0,0,1-1.231-1.772c-.842-1.8-.434-2.658-.877-6.821a5.292,5.292,0,0,1-.009-1.462Z",
    transform: "translate(-181.685 -14.556)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17736",
    "data-name": "Path 17736",
    d: "M187.175,37.861a6.385,6.385,0,0,1-3.233-1.09,4.975,4.975,0,0,1-1.347-1.913,7.882,7.882,0,0,1-.664-3.508c-.035-.859-.08-1.922-.248-3.481a5.485,5.485,0,0,1,0-1.533,7.468,7.468,0,0,1,1.178-2.817c.354-.585.62-.957.859-1.285.089-.124.168-.239.257-.354a24.584,24.584,0,0,0,1.94-3.6,25.631,25.631,0,0,1,1.533-2.923,1.731,1.731,0,0,1,1.116-.85.422.422,0,0,1,.337.08c3.189,2.418,5.262,3.907,6.733,4.828l.133.08a14.084,14.084,0,0,1,3.774,3.233,8.24,8.24,0,0,1,.673.992,4.2,4.2,0,0,0,.381.567,1.917,1.917,0,0,1,.4.78,2.155,2.155,0,0,1,1.5.177,2.872,2.872,0,0,1,1.107,2.888,4.179,4.179,0,0,1-2.232,2.693,7.2,7.2,0,0,1-2.312.992l-.283.611c-.9,1.913-1.409,2.959-2.321,3.694-1.329,1.063-2.782,1.231-5.2,1.506a34.407,34.407,0,0,1-3.446.283c-.23,0-.434-.009-.629-.027ZM200.782,25.99a.446.446,0,0,1-.381-.044.417.417,0,0,1-.195-.328,1.306,1.306,0,0,0-.275-.788,4.323,4.323,0,0,1-.47-.691,6.88,6.88,0,0,0-.6-.895,13.092,13.092,0,0,0-3.561-3.039l-.133-.08c-1.462-.912-3.508-2.374-6.617-4.731a1.281,1.281,0,0,0-.39.416,24.516,24.516,0,0,0-1.479,2.826,25.592,25.592,0,0,1-2.011,3.721l-.266.372a14.443,14.443,0,0,0-.815,1.223,6.658,6.658,0,0,0-1.063,2.489h0a4.918,4.918,0,0,0,.009,1.355c.168,1.55.213,2.631.248,3.5a7.2,7.2,0,0,0,.585,3.189,4.117,4.117,0,0,0,1.116,1.621,5.355,5.355,0,0,0,2.773.9,22.308,22.308,0,0,0,3.889-.257c2.516-.283,3.676-.443,4.757-1.32.726-.585,1.16-1.462,2.082-3.393l.372-.8a.415.415,0,0,1,.3-.239,6.41,6.41,0,0,0,2.224-.912c.833-.549,1.692-1.107,1.851-2.117a2.073,2.073,0,0,0-.682-2,1.158,1.158,0,0,0-.54-.124,2.111,2.111,0,0,0-.735.142Z",
    transform: "translate(-181.628 -14.503)"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17737",
    "data-name": "Path 17737",
    d: "M195.024,26.484c-.071.292-.691.39-1.391.23s-1.2-.532-1.134-.824.691-.39,1.391-.23S195.095,26.192,195.024,26.484Z",
    transform: "translate(-72.827 -10.504)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17738",
    "data-name": "Path 17738",
    d: "M186.144,22.625c-.177.239.159.78.744,1.2s1.2.558,1.373.319-.159-.78-.744-1.2S186.321,22.386,186.144,22.625Z",
    transform: "translate(-72.097 -10.153)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17739",
    "data-name": "Path 17739",
    d: "M209.036,16.914c.151-.354,5.519-7.672,10.064-2.631s.1,12.119-8.185,9.045S209.036,16.914,209.036,16.914Z",
    transform: "translate(-74.445 -9.013)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17740",
    "data-name": "Path 17740",
    d: "M215.831,16.351a8.137,8.137,0,0,1-.54.983l-1.479-5.882a.069.069,0,0,1-.044-.018.669.669,0,0,1,.523-1.231.67.67,0,0,1,.354.877.96.96,0,0,1-.1.159l1.285,5.1Z",
    transform: "translate(-75.208 -8.742)",
    fill: "#f86e6d"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17741",
    "data-name": "Path 17741",
    d: "M191.238,124.165q2.6,0,5.457-.124c3.047-.133,6.3-.381,9.683-.718,2.33-.239,4.7-.514,7.052-.833l.159-.018.071-.009,1.409-.195c4.651-.656,7.76-1.231,7.8-1.24a.4.4,0,0,0,.275-.186.428.428,0,0,0,.062-.328c-.974-4.58-1.816-9.169-2.507-13.642a.426.426,0,1,0-.842.133c.673,4.341,1.488,8.8,2.418,13.253-1,.177-3.694.647-7.326,1.16l-1.32.177a.312.312,0,0,0-.106.018l-.213.027c-2.339.31-4.7.594-7.025.824-3.357.337-6.6.585-9.629.718-3.6.159-6.91.168-9.842.027l-1.417-.08c-1.355-.1-2.64-.221-3.827-.381-12.712-1.727-15.68-3.278-16.318-3.747a40.7,40.7,0,0,0,4.022-10.834,48.546,48.546,0,0,0,.744-14.245l-.062-.78c-.257-3.083-1.028-12.473-.912-15.308.018-.514.053-1.01.106-1.471a16.658,16.658,0,0,1,.718-3.3c.682-2.135,1.373-4.332,2.162-6.5a.429.429,0,1,0-.806-.292c-.788,2.179-1.488,4.385-2.162,6.52a16.852,16.852,0,0,0-.762,3.473c-.053.478-.089.992-.106,1.524-.115,2.888.656,12.314.912,15.414l.062.78a47.157,47.157,0,0,1-.726,14,39.878,39.878,0,0,1-4.093,10.879.437.437,0,0,0-.027.363c.142.363,1.648,2.259,17.133,4.367,1.2.159,2.507.292,3.88.39.478.027.948.062,1.426.089q2.113.106,4.465.106Z",
    transform: "translate(-69.608 -15.116)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17742",
    "data-name": "Path 17742",
    d: "M127.466,77.99l-.266-.283c.345-.328,8.6-8.017,14.679-7.7l-.018.381c-5.909-.31-14.307,7.512-14.4,7.592Z",
    transform: "translate(-65.375 -15.573)",
    fill: "#b68089"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17743",
    "data-name": "Path 17743",
    d: "M157.883,83.979a18.571,18.571,0,0,1-5.36,12.136l-.283-.257a17.677,17.677,0,0,0,2.33-22.368c.213.106.434.2.647.31a18.386,18.386,0,0,1,2.666,10.17Z",
    transform: "translate(-68.233 -15.971)",
    fill: "#b68089"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1191",
    "data-name": "Group 1191",
    transform: "translate(57.639 54.374)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17744",
    "data-name": "Path 17744",
    d: "M140.057,70.429c-4.509.027-16.256.337-17.035,3.614a2.651,2.651,0,0,0,.283,1.913c.85,1.311,3.074,1.258,5.173,1.2a14.306,14.306,0,0,0,4.536-.638,13.276,13.276,0,0,0,7.034-6.1Z",
    transform: "translate(-122.53 -69.995)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17745",
    "data-name": "Path 17745",
    d: "M122.9,76.141a3.1,3.1,0,0,1-.345-2.25c.753-3.18,9.9-3.9,17.452-3.951h0a.435.435,0,0,1,.372.213.408.408,0,0,1,0,.425,13.649,13.649,0,0,1-7.273,6.3,14.608,14.608,0,0,1-4.669.664c-.416.009-.842.018-1.249.018-1.807,0-3.5-.195-4.3-1.417Zm.5-2.046a2.223,2.223,0,0,0,.23,1.586c.718,1.107,2.8,1.063,4.81,1.01a14,14,0,0,0,4.412-.611,12.486,12.486,0,0,0,6.414-5.262c-9.488.115-15.4,1.338-15.857,3.278Z",
    transform: "translate(-122.475 -69.94)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1192",
    "data-name": "Group 1192",
    transform: "translate(53.081 41.532)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17746",
    "data-name": "Path 17746",
    d: "M124.416,78.208a28.549,28.549,0,0,1,6.8-5.953c2.977-1.772,8.469-5.032,14.466-3.118h0V69.11c.08.035.151.071.23.106a14.587,14.587,0,0,1,3.047,1.471c.558.266,1.116.54,1.665.806.213.106.434.2.647.31,1.347.647,2.693,1.3,4.04,1.949,1.134.549,2.268,1.1,3.4,1.639q9.993,4.824,19.976,9.647c2.977-5.67,16.637-31.192,24.379-28.986,2.02.576,3.712,3.065,3.836,3.26,2.879,4.341,1.329,10.09,0,14.2-6.272,19.454-9.408,29.181-19,32.822-7.574,2.87-14.874.425-21.305-1.727a51.246,51.246,0,0,1-14.679-7.769c-.85-.638-1.648-1.285-2.4-1.922-.319-.266-.629-.54-.939-.806l-.283-.257c-.558-.5-1.072-.992-1.568-1.471-1.355,2.232-2.578,4-4.376,4.119-.718.044-2.294-.124-2.835-1.134A1.948,1.948,0,0,1,139.4,94a23.342,23.342,0,0,1,2.6-5.661c-1.116,1.763-2.126,3.216-2.932,4.332-2.029,2.808-2.826,3.517-3.871,3.676a2.95,2.95,0,0,1-2.41-.638,2.876,2.876,0,0,1-.868-2.144,2.187,2.187,0,0,1,.018-.337,6.212,6.212,0,0,1-.594.39,4.145,4.145,0,0,1-4.447.248,3.255,3.255,0,0,1-1.2-1.913c-.283-1.143-.009-2.516,1.843-5.386a26.538,26.538,0,0,1,5.457-6.095,24.911,24.911,0,0,0-8.371,7.875c-.532.859-1.55,2.666-3.26,2.906a3.428,3.428,0,0,1-3.26-1.417c-1.7-2.923,4.048-9.169,6.307-11.632Z",
    transform: "translate(-117.382 -55.498)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17747",
    "data-name": "Path 17747",
    d: "M166.434,104.97a51.935,51.935,0,0,1-14.8-7.831c-.806-.6-1.621-1.258-2.427-1.94-.328-.275-.638-.54-.948-.824l-.283-.257c-.39-.345-.78-.718-1.2-1.107-1.293,2.082-2.56,3.747-4.438,3.862-.842.053-2.6-.168-3.242-1.355a2.408,2.408,0,0,1-.168-1.657c.044-.186.089-.381.151-.585-1.869,2.542-2.693,3.269-3.862,3.455a3.364,3.364,0,0,1-2.764-.744,3.181,3.181,0,0,1-.983-2.011,4.521,4.521,0,0,1-4.863.2,3.582,3.582,0,0,1-1.373-2.162c-.292-1.2-.089-2.649,1.9-5.723a26.157,26.157,0,0,1,1.559-2.162,20.473,20.473,0,0,0-3.738,4.394l-.089.151c-.576.939-1.657,2.7-3.473,2.959a3.868,3.868,0,0,1-3.694-1.63c-1.86-3.189,3.9-9.452,6.352-12.128l.328.275-.319-.292a28.827,28.827,0,0,1,6.9-6.033c2.994-1.781,8.54-5.076,14.67-3.207a.459.459,0,0,1,.213.044l.177.089a14.607,14.607,0,0,1,3.092,1.488l29.367,14.174c5.1-9.674,17.275-30.944,24.68-28.826,2.144.611,3.889,3.154,4.075,3.437,3.2,4.81,1.072,11.4.053,14.581-6.307,19.56-9.47,29.376-19.259,33.087a20.831,20.831,0,0,1-7.459,1.338c-5,0-9.762-1.595-14.139-3.056ZM179.04,85.188a.424.424,0,0,1-.567.186L148.69,71a14.405,14.405,0,0,0-3-1.444l-.089-.044a.234.234,0,0,1-.062-.009h-.027c-5.82-1.851-11.215,1.355-14.121,3.083a28.132,28.132,0,0,0-6.715,5.882h-.009c-1.922,2.108-7.787,8.478-6.245,11.127a3.018,3.018,0,0,0,2.835,1.214c1.417-.2,2.321-1.674,2.861-2.56l.1-.151a25.783,25.783,0,0,1,8.5-8.008.431.431,0,0,1,.576.115.438.438,0,0,1-.071.585,26.44,26.44,0,0,0-5.377,6c-1.816,2.826-2.029,4.057-1.789,5.058a2.782,2.782,0,0,0,1.036,1.665,3.764,3.764,0,0,0,3.978-.266,5.347,5.347,0,0,0,.549-.363.414.414,0,0,1,.47-.027.426.426,0,0,1,.213.416c0,.035-.018.142-.018.292a2.474,2.474,0,0,0,.726,1.825,2.5,2.5,0,0,0,2.055.532c.842-.133,1.524-.647,3.588-3.508,1-1.391,1.984-2.835,2.923-4.314a.428.428,0,0,1,.585-.133.423.423,0,0,1,.142.585,21.92,21.92,0,0,0-2.551,5.528,1.537,1.537,0,0,0,.089,1.072c.4.744,1.7.948,2.436.912,1.595-.1,2.773-1.825,4.04-3.907a.435.435,0,0,1,.31-.2.444.444,0,0,1,.354.115c.549.532,1.063,1.01,1.559,1.462l.283.257c.3.266.611.54.93.806.788.673,1.595,1.311,2.383,1.913a51.279,51.279,0,0,0,14.564,7.707c6.369,2.135,13.58,4.545,21.013,1.727,9.4-3.561,12.526-13.253,18.745-32.547,1.5-4.633,2.666-9.9.053-13.837-.071-.106-1.719-2.551-3.6-3.092a3.422,3.422,0,0,0-.9-.124c-7.238,0-19.321,21.925-22.98,28.888Z",
    transform: "translate(-117.329 -55.444)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1201",
    "data-name": "Group 1201",
    transform: "translate(0 56.19)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1193",
    "data-name": "Group 1193",
    transform: "translate(7.105 61.444)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_188",
    "data-name": "Rectangle 188",
    width: 79.649,
    height: 5.829,
    transform: "translate(80.083 6.263) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17748",
    "data-name": "Path 17748",
    d: "M65.43,147.6v-5.829a.425.425,0,0,1,.425-.425H145.5a.425.425,0,0,1,.425.425V147.6a.425.425,0,0,1-.425.425H65.855A.425.425,0,0,1,65.43,147.6Zm79.649-5.4H66.289v4.97h78.8V142.2Z",
    transform: "translate(-65.43 -141.35)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1194",
    "data-name": "Group 1194",
    transform: "translate(84.069 40.653)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_189",
    "data-name": "Rectangle 189",
    width: 5.563,
    height: 192.607,
    transform: "translate(5.997 193.032) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17749",
    "data-name": "Path 17749",
    d: "M152.31,310.912V118.305a.425.425,0,0,1,.425-.425H158.3a.425.425,0,0,1,.425.425V310.912a.425.425,0,0,1-.425.425h-5.563A.425.425,0,0,1,152.31,310.912Zm5.563-192.181h-4.7V310.478h4.7V118.73Z",
    transform: "translate(-152.31 -117.88)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1195",
    "data-name": "Group 1195",
    transform: "translate(5.953 40.653)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_190",
    "data-name": "Rectangle 190",
    width: 5.563,
    height: 192.607,
    transform: "translate(5.997 193.032) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17750",
    "data-name": "Path 17750",
    d: "M64.13,310.912V118.305a.425.425,0,0,1,.425-.425h5.563a.425.425,0,0,1,.425.425V310.912a.425.425,0,0,1-.425.425H64.555A.425.425,0,0,1,64.13,310.912ZM69.693,118.73h-4.7V310.478h4.7V118.73Z",
    transform: "translate(-64.13 -117.88)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1196",
    "data-name": "Group 1196",
    transform: "translate(0 35.205)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_191",
    "data-name": "Rectangle 191",
    width: 96.923,
    height: 7.388,
    transform: "translate(97.357 7.813) rotate(180)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17751",
    "data-name": "Path 17751",
    d: "M57.41,119.543v-7.388a.425.425,0,0,1,.425-.425h96.923a.425.425,0,0,1,.425.425v7.388a.425.425,0,0,1-.425.425H57.844a.425.425,0,0,1-.425-.425Zm96.923-6.954H58.269v6.529h96.064Z",
    transform: "translate(-57.41 -111.73)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_1200",
    "data-name": "Group 1200",
    transform: "translate(3.188)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17752",
    "data-name": "Path 17752",
    d: "M154.8,107.606l-1.134-3.216h-4.7l-.656,3.393Z",
    transform: "translate(-70.974 -75.688)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17753",
    "data-name": "Path 17753",
    d: "M148.323,107.636l-1.143-3.216h-4.7l-.656,3.393Z",
    transform: "translate(-70.233 -75.691)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17754",
    "data-name": "Path 17754",
    d: "M141.535,107.636,140.4,104.42h-4.7l-.656,3.393Z",
    transform: "translate(-69.459 -75.691)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17755",
    "data-name": "Path 17755",
    d: "M134.955,107.636l-1.143-3.216h-4.7l-.647,3.393Z",
    transform: "translate(-68.708 -75.691)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1199",
    "data-name": "Group 1199",
    transform: "translate(0 0.416)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17756",
    "data-name": "Path 17756",
    d: "M61.054,73.142l13.129,30.58a.354.354,0,0,0,.319.239h47.27c.283,0,.461-.39.31-.7l-14.688-30.58a.362.362,0,0,0-.31-.221H61.373c-.275,0-.452.372-.319.673Z",
    transform: "translate(-61.009 -72.46)",
    fill: "#95b8d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1198",
    "data-name": "Group 1198"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17757",
    "data-name": "Path 17757",
    d: "M61.054,73.142l13.129,30.58a.354.354,0,0,0,.319.239h47.27c.283,0,.461-.39.31-.7l-14.688-30.58a.362.362,0,0,0-.31-.221H61.373c-.275,0-.452.372-.319.673Z",
    transform: "translate(-61.009 -72.46)",
    fill: "#95b8d1"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1197",
    "data-name": "Group 1197",
    clipPath: "url(#clip-path-4)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_192",
    "data-name": "Rectangle 192",
    width: 62.011,
    height: 67.326,
    transform: "translate(-0.345 -17.7)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEYAAABMCAYAAADQtcHiAAAACXBIWXMAAAsSAAALEgHS3X78AAAB10lEQVR4nO2cW24CMQxFB8Rv98DCujwWxh66gFZQaCHEwySx48f1kfhF0dWxM3E0s3jjePr6vvykl73zkkstjPPnh9j6D1J/zMEMMyhMGtMSiJQ1pozRNKRE3RiOMCSsUTPGkh01pgdjPZA7U0ppRhjc5SRqjBc7aogYoxUIpzWsxng2pGQ4YWthcFnTbUwkO2o0p+shEA5rNhkT3Y4aq8EgBnKnqlyEQEbL6c8YZDtq7CIHMmLNnncpcQgdzEg1pDEEe8lJu2fCG9NbTtdg0ppXIHpMjzXZfAmeSij6029Ly0hjCJ6CySb8D5QxLa3iJZi05he4HrPVmmy+BGTZoG/daQzBamrI1qQxBKvBIG/d0MastYq3waBaA99jKGvgg6HYXCZoW3caQ7A5GLQmnMbcKFtFUzBI1qQxDzxak8EQdJUGwtadxhB0N9Po1qQxBEPbb2Rr0pgKl+Yb7iWLXsqHV9PvXc+AepqHDebd8Ybl7OOlnFrOehDG9Bx+2U7LFq0ZmQaEM4ZrNMI6X9G0xtV71zOA+BpIC9LTRPY/lyynmaNVF8ZozJpNf8JAc/huzhgrNxFii2i1xtrVjLoxVu+qVILxcHEnusCynDzdZE4xxt3V7rIsP13msMv8QIOSAAAAAElFTkSuQmCC"
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17759",
    "data-name": "Path 17759",
    d: "M61.054,73.142l13.129,30.58a.354.354,0,0,0,.319.239h47.27c.283,0,.461-.39.31-.7l-14.688-30.58a.362.362,0,0,0-.31-.221H61.373c-.275,0-.452.372-.319.673Z",
    transform: "translate(-61.009 -72.46)",
    fill: "#95b8d1"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17760",
    "data-name": "Path 17760",
    d: "M75.609,104.342h47.27a.781.781,0,0,0,.647-.372.982.982,0,0,0,.053-.939l-14.688-30.58a.782.782,0,0,0-.7-.461H75.334a.425.425,0,0,0-.425.425.431.431,0,0,0,.425.425h32.8L122.808,103.4a.084.084,0,0,1,0,.08H75.671l-4.137-9.638a.43.43,0,0,0-.788.345l4.146,9.656a.777.777,0,0,0,.709.5Z",
    transform: "translate(-62.116 -71.99)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_193",
    "data-name": "Rectangle 193",
    width: 72.854,
    height: 4.642,
    transform: "translate(13.227 31.227)",
    fill: "#95b8d1"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17761",
    "data-name": "Path 17761",
    d: "M75.45,111.827v-4.642a.425.425,0,0,1,.425-.425h72.854a.425.425,0,0,1,.425.425v4.642a.425.425,0,0,1-.425.425H75.884a.425.425,0,0,1-.425-.425Zm72.854-4.208H76.309V111.4H148.3Z",
    transform: "translate(-62.657 -75.958)",
    fill: "#060e12"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "Group_1204",
    "data-name": "Group 1204",
    transform: "translate(113.835 39.941)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17762",
    "data-name": "Path 17762",
    d: "M185.91,78.445s16.7-25.912,23.228-24.76,9.408,5.758,9.408,11.135S210.1,95.339,210.1,95.339s-16.318-4.987-24.184-16.894Z",
    transform: "translate(-185.91 -53.648)",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1203",
    "data-name": "Group 1203"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_17763",
    "data-name": "Path 17763",
    d: "M185.91,78.445s16.7-25.912,23.228-24.76,9.408,5.758,9.408,11.135S210.1,95.339,210.1,95.339s-16.318-4.987-24.184-16.894Z",
    transform: "translate(-185.91 -53.648)",
    fill: "#0d3b66"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1202",
    "data-name": "Group 1202",
    clipPath: "url(#clip-path-5)"
  }, /*#__PURE__*/React.createElement("image", {
    id: "Rectangle_194",
    "data-name": "Rectangle 194",
    width: 36.321,
    height: 72.642,
    transform: "translate(-2.915 -1.921)",
    xlinkHref: "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACkAAABSCAYAAADJhf30AAAACXBIWXMAAAsSAAALEgHS3X78AAAAyElEQVRoge3bzQ1FQBRA4UtdqtCBynSgCn09sZD4WwjncSc539LGMWMxEyb2+rb5HS5+rHorshvGw72uei3yiTpb0BkjKUZSjKQYSTGSUkTkZoGRcXERTjcofeS8WHYkKUZSjKQYSTGSYiTFSIqRlLIis27CwukGpY5cvlg4khQjKUZSjKQYSTGSYiTFSEo5kZk3YeF0g9JGrn8bcyQpRlKMpBhJMZJiJMVIipGUOvv+Jpxu0K3jJ/9+RfbHYm6fkaGtH3wTGRETVeUfIqdwwRIAAAAASUVORK5CYII="
  }))), /*#__PURE__*/React.createElement("path", {
    id: "Path_17765",
    "data-name": "Path 17765",
    d: "M185.91,78.445s16.7-25.912,23.228-24.76,9.408,5.758,9.408,11.135S210.1,95.339,210.1,95.339s-16.318-4.987-24.184-16.894Z",
    transform: "translate(-185.91 -53.648)",
    fill: "#0d3b66"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_17766",
    "data-name": "Path 17766",
    d: "M184.719,31.7a9.329,9.329,0,0,0,1.09.62,5.147,5.147,0,0,0,1.09.381,1.459,1.459,0,0,0,.283.053l.142.027a.775.775,0,0,1,.142.018c.1.009.195.018.292.035.1,0,.195,0,.292.009h.611a5.393,5.393,0,0,1,.656,0,3.476,3.476,0,0,1-.567.372,3.405,3.405,0,0,1-.319.124,1.185,1.185,0,0,0-.159.062l-.168.035c-.115.027-.23.044-.337.062s-.23.009-.345.018a2.434,2.434,0,0,1-.354-.018,2.358,2.358,0,0,1-.345-.062,2.88,2.88,0,0,1-1.249-.629,2.345,2.345,0,0,1-.762-1.116Z",
    transform: "translate(-71.938 -11.201)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17767",
    "data-name": "Path 17767",
    d: "M196.829,25.462h.027a.428.428,0,0,0,.4-.461,5.455,5.455,0,0,0-4.057-3.862.43.43,0,0,0-.124.85,4.732,4.732,0,0,1,3.322,3.065.426.426,0,0,0,.425.4Z",
    transform: "translate(-72.851 -9.996)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17768",
    "data-name": "Path 17768",
    d: "M189.825,20.444a.452.452,0,0,0,.275-.1.424.424,0,0,0,.053-.6,3.967,3.967,0,0,0-3.411-1.178.43.43,0,1,0,.124.85,3.142,3.142,0,0,1,2.622.886.439.439,0,0,0,.328.151Z",
    transform: "translate(-72.128 -9.699)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17769",
    "data-name": "Path 17769",
    d: "M187.149,29.9a.429.429,0,0,0,.275-.762c-.815-.656-1.541-1.479-1.533-1.745a7.833,7.833,0,0,1,1.293-.983,19.11,19.11,0,0,0,2.764-2.162.426.426,0,0,0-.6-.6,19.089,19.089,0,0,1-2.64,2.064,5.323,5.323,0,0,0-1.568,1.311c-.461.824.9,2.108,1.763,2.791a.447.447,0,0,0,.266.1Z",
    transform: "translate(-71.977 -10.268)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17770",
    "data-name": "Path 17770",
    d: "M202.034,31.737h.08a2.446,2.446,0,0,0,2.215-2.268,1.773,1.773,0,0,0-1.107-1.851.432.432,0,0,0-.23.833c.292.08.5.514.478.983-.009.283-.159,1.214-1.515,1.462a.429.429,0,0,0-.345.5.436.436,0,0,0,.425.354Z",
    transform: "translate(-73.866 -10.734)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17771",
    "data-name": "Path 17771",
    d: "M215.271,23.111a5.718,5.718,0,0,0,3.225-.992,4.464,4.464,0,0,0,2.126-3.641.426.426,0,1,0-.85.035,3.618,3.618,0,0,1-1.745,2.9,5.068,5.068,0,0,1-5.014.345.428.428,0,1,0-.354.78,6.483,6.483,0,0,0,2.613.576Z",
    transform: "translate(-75.099 -9.646)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17772",
    "data-name": "Path 17772",
    d: "M203.175,35.04c3.012,0,7.282-3.535,7.37-7.007a.439.439,0,0,0-.416-.443.452.452,0,0,0-.443.416c-.071,2.985-3.88,6.175-6.511,6.175a.425.425,0,0,0-.425.425.431.431,0,0,0,.425.425Z",
    transform: "translate(-73.997 -10.733)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17773",
    "data-name": "Path 17773",
    d: "M210.04,96.122a.437.437,0,0,0,.408-.292c.044-.142,4.686-13.988,7.06-23.228a.43.43,0,0,0-.833-.213c-2.135,8.327-6.13,20.419-6.91,22.767-2.516-.85-16.335-5.909-23.4-16.353,1.258-1.931,10.01-15.14,16.858-21.27a.427.427,0,0,0-.567-.638C195.219,63.558,185.6,78.423,185.5,78.573a.448.448,0,0,0,0,.47c7.867,11.888,24.255,17.018,24.415,17.062A.6.6,0,0,0,210.04,96.122Z",
    transform: "translate(-72.021 -14.065)",
    fill: "#060e12"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_17774",
    "data-name": "Path 17774",
    d: "M133.7,97.139a.433.433,0,0,0,.416-.319c1.435-5.439,6.458-9.683,6.511-9.718a.428.428,0,1,0-.549-.656c-.213.177-5.289,4.456-6.795,10.161a.43.43,0,0,0,.3.523.445.445,0,0,0,.106.018Z",
    transform: "translate(-66.068 -17.439)",
    fill: "#060e12"
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpoloipo);
export default __webpack_public_path__ + "static/media/upoloipo.15538ed15b9d9f38cc6e75d564d999aa.svg";
export { ForwardRef as ReactComponent };